import { SET_CARRITO} from "../constanst";
import * as constant from '../../global/const';

export function setCarrito(carrito) {
    localStorage.setItem(constant.CARRITO, JSON.stringify(carrito));
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_CARRITO,
                payload: carrito,
            });

        } catch (error) {
            console.log(error);
        }
    }
}


